import script from "./setMember.vue?vue&type=script&setup=true&lang=js"
export * from "./setMember.vue?vue&type=script&setup=true&lang=js"

import "./setMember.vue?vue&type=style&index=0&id=6a785f92&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a785f92"]])

export default __exports__